import { TooltipOnTruncated } from '@components/TooltipOnTruncated';
import { isTemplate } from '@helpers/getDocumentMode';
import { ExternalLinkIcon } from '@heroicons/react/outline';
import clsx from 'clsx';

const pillClasses = clsx(
  'inline-flex',
  'items-center',
  'gap-x-1.5',
  'whitespace-nowrap',
  'rounded-xl',
  'bg-gray-100',
  'px-3',
  'py-1',
  'text-xs',
  'font-medium',
  'max-w-8',
  'sm:max-w-16',
  'md:max-w-24',
  'lg:max-w-36',
  'xl:max-w-48',
);

interface SourceResourceCellProps {
  name: string;
  sourceResourceId: string;
  sourceResourceName: string;
  canFollowLink: boolean;
}

export const SourceResourceCell = ({
  name,
  sourceResourceId,
  sourceResourceName,
  canFollowLink,
}: SourceResourceCellProps) => {
  if (!name) {
    return null;
  }

  const url = isTemplate(sourceResourceName) ? `/templates/${sourceResourceId}` : `/contracts/${sourceResourceId}`;

  if (!canFollowLink) {
    return (
      <span className={clsx(pillClasses, 'cursor-default text-gray-900')}>
        <TooltipOnTruncated tooltipContent={name}>{name}</TooltipOnTruncated>
      </span>
    );
  }

  return (
    <a
      className={clsx(pillClasses, 'text-primary-600 cursor-pointer')}
      href={url}
      rel="noreferrer noopener"
      target="_blank"
    >
      <TooltipOnTruncated tooltipContent={name} className="cursor-pointer">
        {name}
      </TooltipOnTruncated>
      <ExternalLinkIcon className="h-4 w-4 shrink-0" />
    </a>
  );
};
